import React from "react"
import {Row, Col} from "antd"
import {useTranslation} from "react-i18next"
import StatisticCardItem from "./StatisticCardItem"
import styles from "./StatisticCards.module.css"

const StatisticCards = () => {
    const {t} = useTranslation(["financialAid"])
    return (
        <div className={styles.wrap}>
            <Row gutter={[24, 12]}>
                <Col span={6}>
                    <StatisticCardItem
                        title={t("refund.label.requested")}
                        value1="24"
                        value2="$24,300"
                        icon="SHARE"
                        className="requested"
                    />
                </Col>
                <Col span={6}>
                    <StatisticCardItem
                        title={t("refund.label.refunded")}
                        value1="24"
                        value2="$28,250"
                        icon="CHECKMARK_CIRCLE"
                        className="refunded"
                    />
                </Col>
                <Col span={6}>
                    <StatisticCardItem
                        title={t("refund.label.rejected")}
                        value1="24"
                        value2="$28,250"
                        icon="CROSS_CIRCLE_FILL"
                        className="rejected"
                    />
                </Col>
                <Col span={6}>
                    <StatisticCardItem
                        title={t("refund.label.lastRefund")}
                        value1="12/03/2022"
                        value2="$28,250"
                        icon="SEND"
                        className="lastRefund"
                        value1ClassName="small"
                    />
                </Col>
            </Row>
        </div>
    )
}

export default StatisticCards
